<template>
  <div>
    <v-menu>
      <template v-slot:activator="{ props }">
        <MenuActivator v-bind="props" data-cy="accountPopoverDropdown" />
      </template>
      <v-list>
        <v-list-item
          :disabled="!hasLogInAsPermission"
          @click="openLogInAs"
          link
          data-cy="logInAsActionItem"
        >
          <template v-slot:prepend>
            <v-icon icon="mdi-arrow-up-bold-box-outline" />
          </template>
          <v-list-item-title>
            {{ $t('accountTable.actionMenu.logInAs') }}
          </v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
  </div>
</template>
<script lang="ts">
import { defineComponent } from 'vue'
import { Buffer } from 'buffer'
import { SlugsEnum } from '@/permissions/SlugsEnum'
import MenuActivator from '@/components/common/buttons/MenuActivator.vue'

export default defineComponent({
  name: 'AccountActionMenu',
  components: {
    MenuActivator
  },
  props: {
    accountId: { type: String, required: true },
    userId: { type: String, required: true },
    sapId: { type: String, required: true },
    email: { type: String, required: true }
  },
  computed: {
    hasLogInAsPermission(): boolean {
      return this.$permissions?.isAllowed(SlugsEnum.LogInAs) || false
    }
  },
  methods: {
    openLogInAs(): void {
      try {
        const encodedUserData = Buffer.from(
          JSON.stringify({
            accountId: this.accountId,
            userId: this.userId,
            sapId: this.sapId,
            email: this.email
          })
        ).toString('base64')

        const logInAsRoute = this.$router.resolve({
          name: 'home-private',
          query: {
            user: encodedUserData
          }
        })

        window.open(logInAsRoute.href)
      } catch {
        // It doesn't open a new tab
      }
    }
  }
})
</script>
